import React, { MouseEventHandler, useImperativeHandle, useRef } from "react";

import { Scrollable, IScrollableRef } from "../../scrollable";
import { Icon, IconName } from "../../icon";

import "../bottom-menu.css";

export const BottomMenuSeparator = () => <span className="bottom-menu__seperator" />;
BottomMenuSeparator.displayName = "BottomMenuSeparator";

/** Currently we use the same interface as the child */
export type IBottomMenuButtonsRef = IScrollableRef;

export interface IBottomMenuButton<T = string> {
	/** Required because it's used as react key */
	id: T;
	// Try to pass an svg Icon in the content property so we can move away from the font icons
	iconName?: IconName;
	/** The Icon component to display */
	children?: React.ReactNode;
	title?: string;
	isActive?: boolean;
	isDisabled?: boolean;
	badgeText?: string;
	onClick: MouseEventHandler<HTMLButtonElement>;
}

/** Groups buttons on a scrollable list */
export const BottomMenuButtons = ({
	onBack,
	showBackButton,
	className,
	scrollableClassName,
	containerClassName,
	children,
	fadeEnd,
	ref,
}: React.PropsWithChildren<{
	onBack?: () => void;
	/** Not yet supported for vertical menu */
	showBackButton?: boolean;
	/** CSS class name for the main container */
	className?: string;
	/** CSS class name for the scrollable child */
	scrollableClassName?: string;
	/** CSS class name for scrollable container */
	containerClassName?: string;
	fadeEnd?: boolean;
	ref?: React.Ref<IBottomMenuButtonsRef>;
}>) => {
	const elRef = useRef<IScrollableRef>(null);
	const backButtonRef = useRef<HTMLButtonElement>(null);

	// With useImperativeHandle we can give control to the parent
	useImperativeHandle(ref, () => elRef.current as IBottomMenuButtonsRef, []);

	return (
		<div className={`bottom-menu__content ${className || ""}`}>
			{showBackButton && (
				<button
					className="bottom-menu__back"
					onClick={onBack}
					type="button"
					ref={backButtonRef}
				>
					<Icon iconName="angle-left" />
				</button>
			)}
			<Scrollable
				ref={elRef}
				className={`bottom-menu__buttons ${scrollableClassName || ""}`}
				containerClassName={`bottom-menu__buttons-container ${containerClassName || ""}`}
				fadeEnd={fadeEnd}
			>
				{children}
			</Scrollable>
		</div>
	);
};
BottomMenuButtons.displayName = "BottomMenuButtons";
